import { css } from 'linaria';

export const info = css`
  max-height: 0;
  padding: 0 var(--space-225);
  overflow: hidden;
  transition-timing-function: ease-out;
  transition-duration: 500ms, 500ms;
  transition-property: max-height, padding-bottom;
`;

export const openInfo = css`
  max-height: inherit;
  padding: 0 var(--space-225) calc(var(--space-225) - 1px);
  transition-duration: 500ms, 50ms;
`;

export const infoAddress = css`
  margin-bottom: var(--space-250);
`;

export const warning = css`
  margin-bottom: var(--space-275);
`;

export const hintButton = css`
  display: flex;
`;

export const divider = css`
  margin: 0 0 var(--space-250);
`;

export const phoneSection = css`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin: var(--space-200) 0 var(--space-250);
`;

export const phoneNumber = css`
  white-space: nowrap;
  color: var(--text-primary);
  :hover {
    color: var(--brand-primary);
  }
`;

export const timeTable = css`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-250);
  margin: var(--space-250) 0 var(--space-250);
`;

export const timeSlot = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const styles = {
  info,
  openInfo,
  infoAddress,
  warning,
  hintButton,
  divider,
  phoneSection,
  phoneNumber,
  timeTable,
  timeSlot,
};
